import { __extends } from "tslib";
import { ASObject } from '@awayfl/avm2';
var TabAlignment = /** @class */ (function (_super) {
    __extends(TabAlignment, _super);
    function TabAlignment() {
        return _super.call(this) || this;
    }
    TabAlignment.forceNativeConstructor = true;
    TabAlignment.forceNativeMethods = true;
    // JS -> AS Bindings
    TabAlignment.START = 'start';
    TabAlignment.CENTER = 'center';
    TabAlignment.END = 'end';
    TabAlignment.DECIMAL = 'decimal';
    return TabAlignment;
}(ASObject));
export { TabAlignment };
